import {
  faChevronDown,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useMemo, useState } from "react";
import { useARRSidebar } from "../../context/SidebarContext";
import { useEducationLevel } from "../../hooks/useEducationLevel";
import { useARRCode } from "../../context/ARRLevelContext";
import Select from "./Select";

const Sidebar = ({
  activeTab,
  setActiveTab,
  arrContents,
  setArrContents,
  name,
  permittedARR,
}) => {
  const { arrLevel, setArrLevel } = useARRCode();
  const { educationLevel, loading } = useEducationLevel();
  const { collapse } = useARRSidebar();
  const [arrOptions, setArrOptions] = useState([]);

  const [menu, setMenu] = useState(arrContents[0]?.name);

  const handleDropdown = (value) => {
    setMenu((prev) => (prev === value ? null : value));
  };

  //extract the permitted arr
  useEffect(() => {
    if (educationLevel?.length === 0 || permittedARR?.length === 0) return;

    const filteredArr = educationLevel?.filter((level) => {
      const matched = permittedARR?.some((arr) => arr?.name === level?.label);
      return matched;
    });

    setArrOptions(filteredArr);
  }, [educationLevel, permittedARR]);

  //display selelcted widget arr in select
  useEffect(() => {
    if (arrOptions?.length > 0) {
      const matched = arrOptions.find((item) => item?.label === name);
      if (matched) {
        setArrLevel(matched.value);
      }
    }
  }, [name, arrOptions, setArrLevel]);

  //display first content of arr at first
  useEffect(() => {
    if (arrContents?.length) {
      setMenu(arrContents[0]?.name);
    }
  }, [arrContents]);

  return (
    <aside className={`${collapse ? "sidebar-collapse" : ""} arr-sidebar`}>
      <div style={{ marginBottom: "24px" }}>
        <Select
          isLoading={loading}
          options={arrOptions}
          value={arrOptions?.find((option) => option.value === arrLevel)}
          onChange={(option) => {
            setArrLevel(option?.value);
            setArrContents(() => {
              const selectedArr = permittedARR?.find(
                (item) => item?.name === option?.label,
              );
              return selectedArr?.contents;
            });
          }}
          isClearable={false}
        />
      </div>
      {arrContents?.map((item, idx) => {
        const active = item?.tabs?.find((a) => a.name === activeTab);
        return (
          <div key={item.name}>
            <div
              className={`${active ? "active" : ""} arr-tabs`}
              onClick={() => handleDropdown(item.name)}
            >
              <p>{item.name}</p>
              <FontAwesomeIcon
                icon={menu === item.name ? faChevronDown : faChevronRight}
              />
            </div>
            <div
              className={`${menu === item.name ? "active" : ""} arr-dropdown`}
            >
              {item.tabs.map((content) => (
                <p
                  key={content.name}
                  className={`${activeTab === content.name ? "active" : ""} item`}
                  onClick={() => setActiveTab(content.name)}
                >
                  {content.name}
                </p>
              ))}
            </div>
          </div>
        );
      })}
    </aside>
  );
};

export default Sidebar;
